import i18n from "@/i18n";

export function ordersTabigation() {
  return [
    {
      label: i18n.t("_.overview"),
      to: {
        name: `adminOrdersOverview`
      }
    },
    {
      label: i18n.t("_.orders_list"),
      to: {
        name: "adminOrdersList"
      }
    }
  ];
}
